var React = require('react');

function HomeIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1672_40440)","key":0},React.createElement("path",{"d":"M8.33341 16.6667V11.6667H11.6667V16.6667H15.8334V10H18.3334L10.0001 2.5L1.66675 10H4.16675V16.6667H8.33341Z","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1672_40440"},React.createElement("rect",{"width":"20","height":"20","fill":"white"})))]);
}

HomeIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = HomeIcon;

HomeIcon.default = HomeIcon;
